(function thumbnailHelper(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousThumbnailHelper = global.NewHomeSource.ThumbnailHelper;

  /**
   * @constructs NewHomeSource.ThumbnailHelper
   */
  function ThumbnailHelper() {
  }

  ThumbnailHelper.defaultThumbs = JSON.parse(document.querySelector('[data-component="defaultThumbnails"]').innerHTML);

  /**
   * @public
   * validate: return thumbnail url valid.
   */
  ThumbnailHelper.validate = function validate(data) {
    const collection = data.CollectionName.split(' ');
    const imageUrl = data.ThumbnailUrl || ThumbnailHelper.defaultThumbs[collection[0]];
    return imageUrl;
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.ThumbnailHelper to the previous script.
   */
  ThumbnailHelper.noConflict = function noConflict() {
    global.NewHomeSource.ThumbnailHelper = previousThumbnailHelper;
    return ThumbnailHelper;
  };

  global.NewHomeSource.ThumbnailHelper = ThumbnailHelper;
}(window));
